module.exports = __webpack_public_path__ + "static/media/33.cc9678ff.jpg";